/* tslint:disable */
/* eslint-disable */
/**
 * Контроль місій для FPV
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface InputVerifyTwoFactorRequest
 */
export interface InputVerifyTwoFactorRequest {
    /**
     * Challenge token from TokenHandler
     * @type {string}
     * @memberof InputVerifyTwoFactorRequest
     */
    challenge: string;
    /**
     * For TOTP
     * @type {string}
     * @memberof InputVerifyTwoFactorRequest
     */
    code?: string;
    /**
     * For WebAuthn
     * @type {string}
     * @memberof InputVerifyTwoFactorRequest
     */
    credential?: string;
    /**
     * "webauthn" or "totp"
     * @type {string}
     * @memberof InputVerifyTwoFactorRequest
     */
    method: InputVerifyTwoFactorRequestMethodEnum;
}


/**
 * @export
 */
export const InputVerifyTwoFactorRequestMethodEnum = {
    Webauthn: 'webauthn',
    Totp: 'totp'
} as const;
export type InputVerifyTwoFactorRequestMethodEnum = typeof InputVerifyTwoFactorRequestMethodEnum[keyof typeof InputVerifyTwoFactorRequestMethodEnum];


/**
 * Check if a given object implements the InputVerifyTwoFactorRequest interface.
 */
export function instanceOfInputVerifyTwoFactorRequest(value: object): boolean {
    if (!('challenge' in value)) return false;
    if (!('method' in value)) return false;
    return true;
}

export function InputVerifyTwoFactorRequestFromJSON(json: any): InputVerifyTwoFactorRequest {
    return InputVerifyTwoFactorRequestFromJSONTyped(json, false);
}

export function InputVerifyTwoFactorRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): InputVerifyTwoFactorRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'challenge': json['challenge'],
        'code': json['code'] == null ? undefined : json['code'],
        'credential': json['credential'] == null ? undefined : json['credential'],
        'method': json['method'],
    };
}

export function InputVerifyTwoFactorRequestToJSON(value?: InputVerifyTwoFactorRequest | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'challenge': value['challenge'],
        'code': value['code'],
        'credential': value['credential'],
        'method': value['method'],
    };
}

